<div class="test-result-container">
    <div class="loading-overlay" *ngIf="isLoading">
        <div class="spinner"></div>
        <p>Starting new attempt...</p>
    </div>

    <div class="header-actions-top">
        <button class="back-btn-top" (click)="goToDashboard()">
            <mat-icon>arrow_back</mat-icon> Back
        </button>
    </div>

    
    <div class="attempt-selector-section" *ngIf="hasMultipleAttempts && allAttemptsData">
        <div class="attempt-selector-header">
            <div class="header-left">
                <mat-icon class="history-icon">history</mat-icon>
                <div class="header-text">
                    <h2>Test Attempts History</h2>
                    <p>{{ totalAttempts }} attempts • View and compare your progress</p>
                </div>
            </div>

            
            <div class="header-right">
                <button mat-button [matMenuTriggerFor]="attemptMenu" class="attempt-dropdown-btn">
                    <span class="dropdown-badge">●</span>
                    <span class="dropdown-text">
                        Attempt #{{ attemptNumber }}
                        <span class="latest-tag" *ngIf="selectedAttemptIndex === 0">(Latest)</span>
                    </span>
                    <mat-icon class="dropdown-icon">expand_more</mat-icon>
                </button>

                <mat-menu #attemptMenu="matMenu" class="attempt-dropdown-menu">
                    <div class="dropdown-header">Select an attempt to view results</div>

                    <button mat-menu-item *ngFor="let attempt of allAttemptsData.attempts; let i = index"
                        class="attempt-menu-item" [class.active]="selectedAttemptIndex === i"
                        (click)="selectAttempt(i)">
                        <div class="menu-item-content">
                            <div class="menu-item-left">
                                <span class="attempt-badge" [class.badge-purple]="i === 0"
                                    [class.badge-green]="i !== 0 && attempt.overall_performance.score_percentage >= 70"
                                    [class.badge-blue]="i !== 0 && attempt.overall_performance.score_percentage < 70">
                                    #{{ getAttemptNumber(i) }}
                                </span>
                                <div class="menu-item-info">
                                    <div class="menu-item-title">
                                        <span *ngIf="i === 0" class="latest-label">Latest Attempt</span>
                                        <span *ngIf="i !== 0">Attempt {{ getAttemptNumber(i) }}</span>
                                    </div>
                                    <div class="menu-item-date">{{ formatAttemptDate(attempt.created_at) }}</div>
                                </div>
                            </div>
                            <div class="menu-item-right">
                                <span class="menu-item-score"
                                    [class.score-high]="attempt.overall_performance.score_percentage >= 70"
                                    [class.score-medium]="attempt.overall_performance.score_percentage >= 40 && attempt.overall_performance.score_percentage < 70"
                                    [class.score-low]="attempt.overall_performance.score_percentage < 40">
                                    {{ attempt.overall_performance.score_percentage }}%
                                </span>
                                <mat-icon class="check-icon" *ngIf="selectedAttemptIndex === i">check_circle</mat-icon>
                            </div>
                        </div>
                    </button>
                </mat-menu>
            </div>
        </div>

        
        <div class="attempts-tabs-container">
            <div class="attempts-tabs">
                <button *ngFor="let attempt of allAttemptsData.attempts; let i = index" class="attempt-tab-card"
                    [class.active]="selectedAttemptIndex === i" [class.latest]="i === 0"
                    [class.score-high]="attempt.overall_performance.score_percentage >= 70"
                    [class.score-medium]="attempt.overall_performance.score_percentage >= 40 && attempt.overall_performance.score_percentage < 70"
                    [class.score-low]="attempt.overall_performance.score_percentage < 40" (click)="selectAttempt(i)">
                    <div class="tab-label" *ngIf="i === 0">Latest</div>
                    <div class="tab-number">#{{ getAttemptNumber(i) }}</div>
                    <div class="tab-score" [class.score-high]="attempt.overall_performance.score_percentage >= 70"
                        [class.score-medium]="attempt.overall_performance.score_percentage >= 40 && attempt.overall_performance.score_percentage < 70"
                        [class.score-low]="attempt.overall_performance.score_percentage < 40">
                        {{ attempt.overall_performance.score_percentage }}%
                    </div>
                    <div class="tab-fraction">{{ attempt.overall_performance.obtained_marks }}/{{
                        attempt.overall_performance.total_marks }}</div>
                </button>
            </div>
        </div>
    </div>

    <div class="results-layout">
        
        <div class="result-card">
            
            <div class="top-section">
                
                <div class="score-circle-wrapper">
                    <div class="score-circle">
                        <svg class="progress-ring" viewBox="0 0 120 120">
                            <circle class="progress-ring-bg" cx="60" cy="60" r="52" fill="none" stroke="#e8e8f0"
                                stroke-width="8" />
                            <circle class="progress-ring-fill" cx="60" cy="60" r="52" fill="none"
                                stroke="url(#scoreGradient)" stroke-width="8" stroke-linecap="round"
                                [attr.stroke-dasharray]="326.7"
                                [attr.stroke-dashoffset]="326.7 - (326.7 * scoreProgressValue / 100)"
                                transform="rotate(-90 60 60)" />
                            <defs>
                                <linearGradient id="scoreGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                    <stop offset="0%" style="stop-color:#7c3aed" />
                                    <stop offset="100%" style="stop-color:#a78bfa" />
                                </linearGradient>
                            </defs>
                        </svg>
                        <div class="score-text">
                            <span class="score-value">{{ obtainedMarks }}</span>
                            <span class="score-total">/ {{ totalMarks }}</span>
                        </div>
                    </div>
                    <div class="trophy-badge">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24"
                            height="24">
                            <path
                                d="M5 3h14a1 1 0 0 1 1 1v3a6 6 0 0 1-4.24 5.73A5.99 5.99 0 0 0 12 20a5.99 5.99 0 0 0-3.76-7.27A6 6 0 0 1 4 7V4a1 1 0 0 1 1-1zm2 2v2a4 4 0 0 0 2.56 3.73A7.94 7.94 0 0 1 12 16.84a7.94 7.94 0 0 1 2.44-5.11A4 4 0 0 0 17 8V5H7zm-4 0a1 1 0 0 1 1-1h1v3a6 6 0 0 1-.08.94A3 3 0 0 1 2 5h1zm17 0a3 3 0 0 1-2.92 2.94A6 6 0 0 1 19 7V4h1a1 1 0 0 1 1 1zm-8 14a2 2 0 1 1 0 4 2 2 0 0 1 0-4z" />
                        </svg>
                    </div>
                </div>

                
                <div class="stats-row">
                    <div class="stat-card">
                        <div class="stat-icon level-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" width="18" height="18">
                                <path d="M12 2L2 7l10 5 10-5-10-5z" />
                                <path d="M2 17l10 5 10-5" />
                                <path d="M2 12l10 5 10-5" />
                            </svg>
                            <span class="stat-label">Industry Level</span>
                        </div>
                        <div class="stat-value level-value">{{ knowledgeLevel }}</div>
                    </div>

                    <div class="stat-card">
                        <div class="stat-icon accuracy-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" width="18" height="18">
                                <circle cx="12" cy="12" r="10" />
                                <circle cx="12" cy="12" r="6" />
                                <circle cx="12" cy="12" r="2" />
                            </svg>
                            <span class="stat-label">Accuracy</span>
                        </div>
                        <div class="stat-value">{{ scorePercentage }}%</div>
                    </div>

                    <div class="stat-card">
                        <div class="stat-icon time-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" width="18" height="18">
                                <circle cx="12" cy="12" r="10" />
                                <polyline points="12 6 12 12 16 14" />
                            </svg>
                            <span class="stat-label">Time Taken</span>
                        </div>
                        <div class="stat-value">{{ timeTaken }}</div>
                    </div>

                    <div class="stat-card">
                        <div class="stat-icon difficulty-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18"
                                height="18">
                                <path
                                    d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" />
                            </svg>
                            <span class="stat-label">Difficulty</span>
                        </div>
                        <div class="stat-value">{{ difficulty }}</div>
                    </div>
                </div>
            </div>

            
            <div class="question-stats-row">
                <div class="question-stat-card total">
                    <span class="question-stat-value">{{ totalQuestions }}</span>
                    <span class="question-stat-label">Total</span>
                </div>

                <div class="question-stat-card correct">
                    <span class="question-stat-value">{{ correctAnswers }}</span>
                    <span class="question-stat-label">Correct</span>
                </div>

                <div class="question-stat-card wrong">
                    <span class="question-stat-value">{{ incorrectAnswers }}</span>
                    <span class="question-stat-label">Wrong</span>
                </div>

                <div class="question-stat-card skipped">
                    <span class="question-stat-value">{{ skippedAnswers }}</span>
                    <span class="question-stat-label">Skipped</span>
                </div>
            </div>

            
            <div class="feedback-section">
                <div class="feedback-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20"
                        height="20">
                        <path
                            d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7z" />
                    </svg>
                </div>
                <p class="feedback-text">{{ overallFeedback }}</p>
            </div>

            
            <app-question-review [questions]="resultData?.test_conversation || []"
            [isPaid]="isPaid"></app-question-review>

            
            <div class="whats-next-section">
                <h3>What's Next?</h3>
                <p>Consistent practice is the fastest way to become industry-ready.</p>

                <div class="action-buttons">
                    <button class="btn-primary" (click)="retakeQuiz()" *ngIf="isRetakePermitted">
                        <mat-icon>refresh</mat-icon> Retake Quiz
                    </button>
                    <button class="btn-secondary" (click)="practiceAnother()">
                        <mat-icon>gps_fixed</mat-icon> Practice Another Quiz
                    </button>
                    <!-- <button class="btn-secondary" (click)="goToDashboard()">
                        <mat-icon>home</mat-icon> Go to Home
                    </button> -->
                </div>
            </div>
        </div>

        
        <div class="insights-column" *ngIf="resultData?.overall_performance as data">
            
            <div class="insight-card strengths-card" *ngIf="data.key_strengths?.length">
                <div class="card-header">
                    <mat-icon>star_outline</mat-icon>
                    <h3>Key Strengths</h3>
                </div>
                <div class="summary-box" *ngIf="correctAnswers > incorrectAnswers">
                    <mat-icon>check_circle_outline</mat-icon>
                    <span>More correct answers than incorrect ones</span>
                </div>
                <ul class="insights-list">
                    <li *ngFor="let strength of data.key_strengths">
                        <mat-icon>check_circle</mat-icon>
                        <span class="text">{{ strength }}</span>
                    </li>
                </ul>
            </div>

            
            <div class="insight-card improvements-card" *ngIf="data.areas_to_improve?.length">
                <div class="card-header">
                    <mat-icon>trending_up</mat-icon>
                    <h3>Areas to Improve</h3>
                </div>
                <ul class="insights-list">
                    <li *ngFor="let area of data.areas_to_improve">
                        <mat-icon>arrow_forward</mat-icon>
                        <span class="text">{{ area }}</span>
                    </li>
                </ul>
                <div class="encouragement">
                    <div class="emoji">💪</div>
                    <p>Don't worry! Every expert was once a beginner. Keep practicing!</p>
                </div>
            </div>
        </div>
    </div>
</div>